import { Form, Input, message, Modal, Spin, Typography } from 'antd';
import { License } from '../../../../types';
import { useEffect, useState } from 'react';
import { updateExtraForLicense } from '../../../../utils/httpRequest';

const UpdateExtraModal = ({
  open,
  license,
  onConfirm,
  onClose,
}: {
  open: boolean;
  license?: License;
  onConfirm: () => void;
  onClose: () => void;
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleOk = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const payload = {
        ...license,
        ...form.getFieldsValue(),
      };
      await updateExtraForLicense(license?.licenseKey || '', payload);
      onConfirm();
    } catch (err: any) {
      if (!err?.errorFields) {
        messageApi.error(err?.message || 'Update failed!');
      }
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        extraTemplates: license?.extraTemplates || 0,
        extraMachines: license?.extraMachines || 0,
      });
    } else {
      form.resetFields();
    }
  }, [open, license]);

  return (
    <Modal
      open={open}
      title="Core license - Update extra"
      onCancel={onClose}
      onClose={onClose}
      onOk={handleOk}
      okText="Update"
      confirmLoading={loading}
    >
      {contextHolder}
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item
            label="Extra templates"
            name="extraTemplates"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && Number(value) < 0) {
                    return Promise.reject(
                      new Error('Extra Template number must be >= 0')
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            label="Extra machines"
            name="extraMachines"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && Number(value) < 0) {
                    return Promise.reject(
                      new Error('Extra Machine number must be >= 0')
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default UpdateExtraModal;
